import surveyMdl from "./survey.mdl"

export default [...surveyMdl];
